import React from 'react';
import { Modal, ModalControls } from '../Modal';
import { HBox } from '../Box';
import { Button } from '../Buttons';
import { Loader } from '../Loader';

export const LoadingWithNotification = ({ message }) => {
  return (
    <Modal>
      <HBox center vCentr>
        <strong>{message}</strong>
      </HBox>
      <ModalControls>
        <Button small disabled>
          <Loader small />
        </Button>
      </ModalControls>
    </Modal>
  );
};
